export interface ISelectableRows {
  selectedRows: Record<string, unknown>;
  isSelectAll: boolean;
  handleCheckRowSelected: (_row: unknown, index: number) => boolean;
  handleSelectRowChange: (row: unknown, index: number) => void;
  handleSelectAllRowsChange: () => void;
  handleSelectAllSamples: () => void;
  handleDeselectAllSamples: () => void;
  allRowsSelected: boolean;
  resetSelectedRows: () => void;
  hasSelectedRows: boolean;
}
